


















import {Component, Vue, Prop} from 'vue-property-decorator'
import {Getter, Mutation} from 'vuex-class'
import {InventoryItem, Room, Task} from '@/store/types'
import FontAwesome from '@/classes/FontAwesome'
import {Touch} from '@/components/common'

@Component({
  components: {
    Touch,
  },
})
export default class InventoryRoom extends Vue {
  @Prop({type: Object, required: true}) public room!: Room
  @Prop({type: Number, required: true}) public index!: number
  @Getter('task') public task!: Task
  @Getter('inventory') public inventory!: InventoryItem[]
  @Getter('activeRoomId') public activeRoomId!: number
  @Getter('showInventoryEditRoomOverlay') public showInventoryEditRoomOverlay!: boolean
  @Mutation('setInventoryEditRoomOverlay') public setInventoryEditRoomOverlay!: any
  @Mutation('setInventoryItemListOverlay') public setInventoryItemListOverlay!: any
  @Mutation('setActiveRoomId') public setActiveRoomId!: any
  @Mutation('setActiveGroups') public setActiveGroups!: any
  @Mutation('setLoader') public setLoader!: any
  public FontAwesome = FontAwesome

  public get roomInventory() {
    return this.inventory.filter((i) => i.lead_room_id === this.room.id)
  }
  public get roomVolume() {
    return this.roomInventory.reduce((carry, item) => {
      return carry += item.volume * item.quantity
    }, 0)
  }

  public roomName(name: string) {
      return name.includes('Master') ? name.replace('Master', 'Mast.') : name
  }

  public setActiveRoom() {
    this.setActiveGroups(this.room.room_id)
    this.setActiveRoomId(this.room.id)
    this.scrollActiveRoom()
    this.$router.push({ path: `rooms/${this.room.id}/items`})
  }

  public roomAction() {
    this.setLoader(true)
    this.setActiveRoom()
    this.setLoader(false)
  }

  public editRoom() {
    this.setActiveRoomId(this.room.id)
    this.setInventoryEditRoomOverlay(true)
  }

  public activeRoomState() {
    this.setActiveRoomId(this.room.id)
  }

  public resetRoomState() {
    if (!this.showInventoryEditRoomOverlay) {
      this.setActiveRoomId(0)
    }
  }

  public scrollActiveRoom() {
    const rooms = document.querySelector('.inventory') as HTMLElement
    let currentIndex = null
    currentIndex = this.index

    if (currentIndex !== null) {
      rooms.scrollLeft = currentIndex * (rooms.clientWidth / 4)
    } else {
      rooms.scrollLeft = 0
    }
  }
}
